module.exports = __webpack_public_path__ + "media/about/AboutUs-OurStory-2-8fb032ec.png";